import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import type { IEntityStatusInfo, ISubDivisionInfo, ITeamInfo, IUserInfo, Ticket } from "@kiraah-shared/common";
import { TranslateModule } from "@ngx-translate/core";
import type { MobileTicketWizardComponent } from "../../mobile-ticket-wizard-page.component";

@Component({
  selector: "mobile-ticket-general-info-step",
  standalone: true,
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, FormsModule],
  templateUrl: "./mobile-ticket-general-info-step.component.html",
  styleUrl: "./mobile-ticket-general-info-step.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileTicketGeneralInfoStepComponent {
  readonly wizard = input.required<MobileTicketWizardComponent>();
  readonly ticket = input.required<Ticket>();

  protected ticketStatusTrack(index: number, s: IEntityStatusInfo): string {
    return this.wizard().ticketStatusTrack(index, s);
  }

  protected teamTrack(index: number, row: ITeamInfo): string {
    return this.wizard().teamTrack(index, row);
  }

  protected identityTrack(index: number, row: IUserInfo): string {
    return this.wizard().identityTrack(index, row);
  }

  protected subDivisionTrack(index: number, row: ISubDivisionInfo): string {
    return this.wizard().subDivisionTrack(index, row);
  }
}
